import { multiStyleConfig } from "@chakra-ui/theme-tools";
var alignments = {
  end: "flex-end",
  center: "center",
  start: "flex-start"
};
var tabs = multiStyleConfig({
  parts: {
    tablist: "the tab list or button group",
    tab: "the tab button",
    tabpanel: "the tab content",
    indicator: "the active tab indicator"
  },
  baseStyle: function baseStyle(props) {
    var _props$align = props.align,
        align = _props$align === void 0 ? "start" : _props$align,
        isFitted = props.isFitted;
    return {
      tab: {
        flex: isFitted ? 1 : undefined,
        transition: "all 0.2s",
        mr: "4",
        _focus: {
          zIndex: 1,
          boxShadow: "outline"
        }
      },
      tablist: {
        justifyContent: alignments[align]
      },
      tabpanel: {
        padding: 4
      }
    };
  },
  sizes: {
    sm: {
      tab: {
        paddingY: "0.25rem",
        paddingX: "1rem",
        fontSize: "0.85rem"
      }
    },
    md: {
      tab: {
        fontSize: "1rem",
        paddingY: "0.5rem",
        paddingX: "1rem"
      }
    },
    lg: {
      tab: {
        fontSize: "1.15rem",
        paddingY: "0.75rem",
        paddingX: "1rem"
      }
    }
  },
  variants: {
    link: function link(props) {
      return {
        tab: {
          color: "gray.700",
          borderBottom: "2px solid transparent",
          fontWeight: "bold",
          _selected: {
            color: "teal.200",
            borderColor: "currentColor"
          },
          _hover: {
            color: "teal.300",
            borderColor: "currentColor"
          },
          _disabled: {
            color: "gray.500",
            cursor: "not-allowed",
            borderColor: "transparent"
          }
        }
      };
    },
    pill: function pill(props) {
      return {
        tab: {
          color: "gray.700",
          fontWeight: "bold",
          borderRadius: "4px",
          _selected: {
            background: "teal.100",
            color: "teal.300"
          },
          _hover: {
            background: "teal.100",
            color: "teal.200"
          },
          _disabled: {
            background: "transparent",
            color: "gray.500",
            cursor: "not-allowed"
          }
        }
      };
    },
    unstyled: {}
  },
  defaultProps: {
    size: "md",
    variant: "pill",
    colorScheme: "teal"
  }
});
export default tabs;